import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DialogLayoutDisplay } from '@costlydeveloper/ngx-awesome-popup';
import { DsAuthJWTToken, DsHTTPStatus } from '@direction/auth';
import { Observable, catchError, throwError } from 'rxjs';
import { HelpersService } from './helpers.service';

@Injectable()
export class SgaInterceptorService implements HttpInterceptor {
  urlsToNotUse: Array<string>;

  constructor(private httpStatus: DsHTTPStatus, private helpersService: HelpersService) {}

  interceptorFilter(req) {
    const urls = '/capture/';
    if (req.url.indexOf(urls) >= 0) {
      return true;
    }
    return false;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token: DsAuthJWTToken = new DsAuthJWTToken();

    if (token.isValid()) {
      const headers = request.headers.set('Authorization', `Bearer ${token.getValue()}`);
      request = request.clone({ headers });
    }

    if (this.interceptorFilter(request) || request.headers.has('ds-autocomplete-request')) {
      this.httpStatus.setHttpStatus(false);
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          window.location.pathname.includes('/shared/grid/') &&
          request.method === 'DELETE' &&
          request.url.includes('/exercises/')
        ) {
          this.helpersService.showToast(
            DialogLayoutDisplay.DANGER,
            'Erro!',
            error.error.notifications[0]?.errors[0]?.errorMessage ?? 'Ocorreu um erro ao tentar deletar o exercício!'
          );
        }

        return throwError(error);
      })
    );
  }
}
